<template>
  <a-tabs
      v-model:activeKey="type"
      style="background-color: #fff; padding: 0 12px"
      @change="getTableData"
  >
    <a-tab-pane key="1" tab="按时间"></a-tab-pane>
    <a-tab-pane key="2" tab="按人员"></a-tab-pane>
    <a-tab-pane key="3" tab="按房间"></a-tab-pane>
  </a-tabs>

  <div style="background-color: #fff; padding: 0 10px 10px 10px">
    <!-- 搜索 -->
    <div ref="topDom" class="header-bar">
      <div class="bar-lef">
        <div class="lef-group">
          <div class="group-one" style="width: 220px">
            <a-range-picker
                v-model:value="rangePicker"
                :allowClear="false"
                :ranges="ranges"
                @change="handlePicker"
            />
          </div>
          <div class="group-one">
            <a-select
                v-model:value="searchForm.mid"
                :filterOption="tasknumberFilter"
                placeholder="被分配人"
                show-search
                @change="getTableData"
            >
              <a-select-option
                  v-for="(item, index) in searchList.taskmember.list"
                  :key="index"
                  :value="item.id"
              >{{ item.name }}
              </a-select-option
              >
            </a-select>
          </div>
          <div class="group-one">
            <a-select
                v-model:value="searchForm.type"
                placeholder="类型"
                @change="getTableData"
            >
              <a-select-option
                  v-for="(item, index) in searchList.tasktype.list"
                  :key="index"
                  :value="item.id"
              >{{ item.name }}
              </a-select-option
              >
            </a-select>
          </div>
          <div class="group-one">
            <a-select
                v-model:value="searchForm.status"
                placeholder="状态"
                @change="getTableData"
            >
              <a-select-option
                  v-for="(item, index) in searchList.taskstatus.list"
                  :key="index"
                  :value="item.id"
              >{{ item.name }}
              </a-select-option
              >
            </a-select>
          </div>
        </div>
        <div class="lef-one">
          <a-input-search
              v-model:value="searchForm.hname"
              :loading="searchLoading"
              placeholder="请输入房间名称"
              @search="getTableData"
          >
          </a-input-search>
        </div>
        <div class="lef-one-no-shadow">
          <a-button type="link" @click="handleReset">重置筛选</a-button>
        </div>
      </div>
      <div class="bar-rig">
        <!-- <div class="rig-one">
          <a-button><user-outlined />成员</a-button>
        </div> -->
      </div>
    </div>

    <!-- 表格 -->
    <a-table
        :columns="columns"
        :dataSource="dataSource"
        :loading="searchLoading"
        :pagination="false"
        :scroll="{ x: columns.length > 6 ? 1500 : 0, y: tableHeight }"
        bordered
        class="table"
        size="small"
    >
    </a-table>
  </div>
</template>

<script>
import {onMounted, reactive, toRefs, watch} from "vue";
import {getSearchList, taskStatToDate, taskStatToHouse, taskTaskMeter,} from "@/api/api";
import dayjs from "dayjs";
// import { UploadOutlined } from "@ant-design/icons-vue";
import useUtils from "@/hooks/useUtils.js"; //工具库
import store from "@/store/pms/landlord/index"; //VUEX

export default {
  //   components: {
  //     UploadOutlined,
  //   },
  setup() {
    let {countTable} = useUtils();
    const search = reactive({
      type: 1,
      topDom: "",
      searchLoading: false,
      searchForm: {
        hname: "",
        mid: [],
        status: [],
        type: [],
        start_date: dayjs().startOf("month").format("YYYY-MM-DD"),
        end_date: dayjs().endOf("month").format("YYYY-MM-DD"),
      },
      rangePicker: [dayjs().startOf("month"), dayjs().endOf("month")],
      searchList: {
        deposit: {},
        group: {},
        income: {},
        inout: {},
        paytype: {},
        room: {},
        source: {},
        tag: {},
        taskmember: {},
        taskstatus: {},
        tasktype: {},
      },
      ranges: {
        昨天: [dayjs().subtract(1, "day"), dayjs().subtract(1, "day")],
        今天: [dayjs(), dayjs()],
        明天: [dayjs().add(1, "day"), dayjs().add(1, "day")],
        最近7天: [dayjs().subtract(7, "day"), dayjs()],
        最近30天: [dayjs().subtract(30, "day"), dayjs()],
        上月: [
          dayjs().subtract(1, "month").startOf("month"),
          dayjs().subtract(1, "month").endOf("month"),
        ],
        本月: [dayjs().startOf("month"), dayjs().endOf("month")],

        上季度: [
          dayjs().startOf("month").add(-1, "year").month(9),
          dayjs().endOf("month").add(-1, "year").month(11),
        ],
        本季度: [
          dayjs().startOf("month").month(0),
          dayjs().endOf("month").month(2),
        ],
      },
      getSearchData() {
        if (!search.searchList.length) {
          getSearchList().then((res) => {
            search.searchList = res.data;
          });
        }
      },
      handlePicker(_params, value) {
        search.searchForm.start_date = value[0];
        search.searchForm.end_date = value[1];
        table.getTableData();
      },
      handleReset() {
        search.searchForm.hname = "";
        search.searchForm.start_date = dayjs()
            .startOf("month")
            .format("YYYY-MM-DD");
        search.searchForm.end_date = dayjs()
            .endOf("month")
            .format("YYYY-MM-DD");
        search.searchForm.mid = [];
        search.searchForm.status = [];
        search.searchForm.type = [];
        search.rangePicker = [dayjs().startOf("month"), dayjs().endOf("month")];
        table.getTableData();
      },
      tasknumberFilter(input, option) {
        return (
            option.children[0].children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
        );
      },
    });

    const table = reactive({
      tableHeight: "",
      dataSource: [],
      initColumns: [],
      countDate: {},
      columns: [],
      timeColumns: [
        {
          title: "时间",
          dataIndex: "name",
          key: "name",
          align: "center",
          width: 100,
          fixed: "left",
        },
        {
          title: "入住数",
          dataIndex: "check_in",
          key: "check_in",
          align: "center",
          width: 100,
        },
        {
          title: "退房数",
          dataIndex: "check_out",
          key: "check_out",
          align: "center",
          width: 100,
        },
        {
          title: "任务数",
          dataIndex: "task_num",
          key: "task_num",
          align: "center",
          width: 100,
        },
        {
          title: "费用",
          dataIndex: "amount",
          key: "amount",
          align: "center",
          width: 100,
        },
      ],
      peopleColumns: [
        {
          title: "人员",
          dataIndex: "name",
          key: "name",
          align: "center",
          width: 100,
          fixed: "left",
        },
        {
          title: "任务数",
          dataIndex: "task_num",
          key: "task_num",
          align: "center",
          width: 100,
        },
        {
          title: "费用",
          dataIndex: "task_amount",
          key: "task_amount",
          align: "center",
          width: 100,
        },
      ],
      houseColumns: [
        {
          title: "房间",
          dataIndex: "name",
          key: "name",
          align: "center",
          width: 100,
          fixed: "left",
        },
        {
          title: "入住数",
          dataIndex: "check_in",
          key: "check_in",
          align: "center",
          width: 100,
        },
        {
          title: "退房数",
          dataIndex: "check_out",
          key: "check_out",
          align: "center",
          width: 100,
        },
        {
          title: "任务数",
          dataIndex: "task_num",
          key: "task_num",
          align: "center",
          width: 100,
        },
        {
          title: "费用",
          dataIndex: "amount",
          key: "amount",
          align: "center",
          width: 100,
        },
      ],
      getTableData() {
        search.searchLoading = true;
        let obj = {
          mid: search.searchForm.mid.toString(),
          status: search.searchForm.status.toString(),
          type: search.searchForm.type,
          hname: search.searchForm.hname,
          start_date: search.searchForm.start_date,
          end_date: search.searchForm.end_date,
        };
        if (search.type == 1) {
          table.columns = table.timeColumns;
          taskStatToDate(obj)
              .then((res) => {
                table.dataSource = res.data;
                search.searchLoading = false;
              })
              .catch(() => {
                search.searchLoading = false;
              });
        } else if (search.type == 2) {
          table.columns = table.peopleColumns;
          taskTaskMeter(obj)
              .then((res) => {
                table.dataSource = res.data.list;
                table.dataSource.unshift({
                  name: res.data.top.mname,
                  task_num: res.data.top.task_num,
                  task_amount: res.data.top.task_amount,
                });
                search.searchLoading = false;
              })
              .catch(() => {
                search.searchLoading = false;
              });
        } else if (search.type == 3) {
          table.columns = table.houseColumns;
          taskStatToHouse(obj)
              .then((res) => {
                table.dataSource = res.data;
                search.searchLoading = false;
              })
              .catch(() => {
                search.searchLoading = false;
              });
        }
      },
    });

    watch(
        () => store.state.ContentHeight,
        () => {
          table.tableHeight = countTable(search.topDom) - 50;
        }
    );

    onMounted(() => {
      search.getSearchData();
      table.getTableData();
      table.tableHeight = countTable(search.topDom) - 50;
    });

    return {
      dayjs,
      ...toRefs(search),
      ...toRefs(table),
    };
  },
};
</script>

<style lang="scss">
.fRed {
  color: red;
}

.count {
  display: flex;
  justify-content: center;
  margin: 10px;

  .bar {
    margin: 0 40px;
  }

  .text {
    margin-left: 5px;
  }
}
</style>
